export enum SelectionType {
    sport = 'sport',
    special = 'specials'
}

export enum BetType {
    prematch = 'prematch',
    live = 'live',
    lotto = 'lotto',
}

export enum BetSlipType {
    simple = 1,
    system = 2
}

export enum BetSlipPurchaseType {
    online = 'online',
    offline = 'offline'
}

/**
 * Define all available rule types that can be sent in IEventDto mrls
 */
export enum RuleType {
    countRestrictions = 'special_count_restriction',
    prohibitionOfSameMarket = 'prohibition_of_same_class',
    prohibitWith = 'prohibit_with',
    checkMinStakeAmount = 'check_stake_amount',
    prohibitionOfSameMatch = 'prohibition_of_same_match'
}

/**
 *  6: M: match sport
 *   S: Specijal
 *   CLS: bet groupa (class) specijal
 *   CL: bet grupa sport
 *   E: u web slucaju isto match (event)
 *   ES: specijal
 *   T: mislim da je turnir
 */
export enum ProhibitionType {
    M = 'M',
    S = 'S',
    CLS = 'CLS',
    CL = 'CL',
    E = 'E',
    T = 'T',
    ES = 'ES',
}

export enum BetSlipErrorType {
    errorsInSelection = 'errorsInSelection',
    chooseTicketNegotiation = 'chooseTicketNegotiation',
    eventCantPlaceBets = 'eventCantPlaceBets',
    oddIsUnavailable = 'oddIsUnavailable',
    sameMarket = 'sameMarket',
    cantCombineEvents = 'cantCombineEvents',
    cantCombineMarkets = 'cantCombineMarkets',
    minSystemToPlay = 'minSystemToPlay',
    cantCombine = 'cantCombine',
    RetailEventStarted = 'RetailEventStarted',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/shared/betSlip/betSlipEnums.ts